<template>
  <div>
    <el-row style="padding-bottom:10px;" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span><label>编号：</label>
        <el-input class="search-input" v-model="id" placeholder="请输入编号"></el-input>
        </span>
        <span><label>序列号：</label>
        <el-input class="search-input" v-model="deviceSn" placeholder="请输入序列号"></el-input>
        </span>
        <span><label>设备类型:</label>
        <DropdownSelect
          v-model="deviceTypeId"
          :action="api.shop.device.listtype"
          textField="name"
          valueField="id"
        ></DropdownSelect>
        </span>
        <span>
        <el-button type="primary" @click="search">搜索</el-button></span>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.shop.device"
      :viewable="false"
      keyField="id"
      :deletable="false"
      :editable="false"
    >
      <el-table-column prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="deviceSn" v-if="!isMobile()" label="序列号"></el-table-column>
      <el-table-column prop="deviceTypeName" label="设备类型"></el-table-column>
      <el-table-column prop="deviceCategoryName" label="设备名称"></el-table-column>
      <!--<el-table-column prop="status" label="状态"></el-table-column>-->
      <el-table-column label="二维码">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleQrcode(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="!isMobile()" prop="created" label="添加时间" :formatter="dateFormatter"></el-table-column>
    </page-table>
    <el-dialog title="查看二维码" :visible.sync="qrcode.dialogVisible" :width="isMobile()?'80%':'50%'">
      <p>
        <span>下载二维码请"右击"图片选择"另存为"</span>
      </p>
      <p class="center">
        <img :src="qrcode.imageUrl" style="max-width:100%" />
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qrcode.dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      id: null,
      deviceSn: "",
      deviceTypeId: null,
      qrcode: {
        dialogVisible: false,
        imageUrl: null
      },
      deviceTypeList: []
    };
  },
  created: function() {
    let that = this;
    let query = that.getQuery();
    that.id = query.id ? parseInt(query.id) : null;
    that.deviceSn = query.deviceSn;
    that.deviceTypeId = query.deviceTypeId
      ? parseInt(query.deviceTypeId)
      : null;
  },
  watch: {},
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    search() {
      let params = this.getQuery();
      params.deviceSn = this.deviceSn;
      params.deviceTypeId = this.deviceTypeId;
      params.id = this.id;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function() {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
    handleQrcode(index, row) {
      this.qrcode.imageUrl = "/shop/device/" + row.id + "/qrcode";
      this.qrcode.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
  .qrcode-dialog{
    width: 80%;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
  .qrcode-dialog{
    width: 50%;
  }
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label {
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?1abd7572